module.exports = __webpack_public_path__ + "af.4bde77199333f65a1aad.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/af.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/af.svg
// module chunks = styles